import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DXCAuthService } from './dxc-auth.service';

export const authLayoutGuard: CanActivateFn = () => {
  const router = inject(Router);
  const dxcAuthService = inject(DXCAuthService);
  const authToken = dxcAuthService.getAuthToken();
  const isLoggedIn = dxcAuthService.isLoggedIn();

  if (!authToken || !isLoggedIn) {
    return true;
  }

  const returnUrlParams =
    router.routerState.snapshot.url.length > 1
      ? { queryParams: { returnUrl: router.routerState.snapshot.url } }
      : {};
  router.navigate([], returnUrlParams);
  return false;
};
